export enum PUBLIC_PAGES {
  LANDING = '/landing',
  UI = '/ui',
  LOGIN = '/login',
  RESET_PASSWORD = '/reset-password',
  SET_NEW_PASSWORD = '/set-new-password',
  PRIVACY_POLICY = '/privacy-policy',
  TERMS_OF_USE = '/terms-of-us',
}

export enum PRIVATE_PAGES {
  HOME = '/',
  BOOK_TICKET = '/request-teetime',
  MY_ACCOUNT = '/my-account',
  CHAT = '/schedule-assistant',
  HELP_CENTER = '/help-center',
}
